<template>
    <CustomHeader :text="$t('offers.depositReturn')" />
    <div class="offers_page">
        <img :src="dataSet.floatImage" alt="">
        <div class="timer">
            <div class="timeBox" v-if="dataSet.isActivityEnableTime">
                <div class="timeTitle">{{ $t('offers.remainTieTitle') }}</div>
                <div class="timer_countdown">
                    {{ dataSet.days > 0 ? dataSet.days : '' }}<span v-if="dataSet.days > 0" style="margin-right: 25px;"> {{ $t('common.days') }}
                    </span>
                    {{ dataSet.hours }}<span> {{ $t('offers.hours') }} </span>
                    {{ dataSet.minutes }}<span> {{ $t('offers.minutes') }} </span>
                    {{ dataSet.seconds }}<span> {{ $t('offers.seconds') }} </span>
                </div>
            </div>
            <div v-else class="timeBox">
                <div class="timeTitle">{{ $t('offers.untilStartPromoTitle') }}</div>
                <div class="timer_countdown">
                    {{ dataSet.days > 0 ? dataSet.days : '' }}<span v-if="dataSet.days > 0" style="margin-right: 25px;"> {{ $t('common.days') }}
                    </span>
                    {{ dataSet.hours }}<span> {{ $t('offers.hours') }} </span>
                    {{ dataSet.minutes }}<span> {{ $t('offers.minutes') }} </span>
                    {{ dataSet.seconds }}<span> {{ $t('offers.seconds') }} </span>
                </div>
            </div>
        </div>
        <div class="promo_wrapper">
            <img src="@/assets/offers/deposit_promotions_title.png" alt="">
            <div class="promo_title">{{ $t(`offers.${getDayNameFromTimestamp(dataSet.endTime)}`) }}</div>
            <div class="promotion_card_list">
                <PromotionCard :cardData="item" :isActivityEnable="dataSet.isActivityEnableTime"
                    v-for="(item, index) in dataSet.activityList" :key="index" :dayName="getDayNameFromTimestamp(dataSet.endTime)" />
            </div>
        </div>
        <div class="bottom_text">
            <van-row style="padding-bottom: 10px;">
                <van-col span="6" class="">
                    <div class="line1"></div>
                </van-col>
                <van-col span="12" class="title">
                    <div>{{ $t('common.activityTitle') }}</div>
                </van-col>
                <van-col span="6" class="">
                    <div class="line2"></div>
                </van-col>
            </van-row>
            <div class="line_text" v-for="value in dataSet.activityIntro" :key="value">
                {{ value }}
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">

import CustomHeader from '../../themeOne/components/common/customHeader.vue';
import PromotionCard from './components/promotionCard.vue';
import { OffersView } from '@/view/offers/supportScript';
import { defineProps } from 'vue'

const props = defineProps<{
    dataSet: OffersView
}>()


const getDayNameFromTimestamp = (timestamp: number): string => {
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", { weekday: "long" });
}

</script>
<style scoped>
.offers_page {
    padding-top: 50px;
}

.offers_page img {
    width: 100%;
}

.timer {
    padding: 5px 20px;
    position: relative;
}

.timeBox {
    border-radius: 10px;
    padding: 10px;
    background-image: linear-gradient(0deg, #69482a 0%, rgb(43 30 23) 100%);
    border: 1px solid #dd7a33;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
}

.timeTitle {
    color: rgb(246 220 180);
    font-size: 16px;
    font-weight: 900;
    -webkit-text-stroke: 1px rgb(172 74 33);
    display: flex;
    justify-content: center;
}

.timer_countdown {
    font-size: 6vw;
    font-weight: bold;
    color: #000;
    background-image: linear-gradient(0deg, rgb(240, 168, 83) 0%, rgb(248, 216, 167) 100%);
    padding: 5px 20px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: 10px;
}

.timer_countdown span {
    color: #FFEE00;
    font-size: 2.8vw;
    background-color: rgba(0, 0, 0, 0.85);
    border-radius: 5px;
    padding: 5px;
    margin: 0 5px;
    font-weight: 200;
}

.promo_wrapper {
    position: relative;
    /* display: inline-block; */
}

.promo_wrapper img {
    width: 100%;
    display: block;
}

.promo_title {
    position: absolute;
    top: 6%;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #993900;
    font-weight: 700;
    font-size: 24px;
    text-shadow: 1px 1px 1px #F0A853;
    z-index: 2;
}

.promotion_card_list {
    position: static;
    margin-top: -120px;
    padding: 0 20px;
}

.bottom_text {
    padding: 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
}

@media (min-width: 500px) {
    .timer_countdown {
        top: 35px;
        left: 3.6vw;
        font-size: 32px;
        height: 45%;
    }

    .timer_countdown span {
        font-size: 12px !important;
    }
}
</style>